import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import DaumPostcodeEmbed from "react-daum-postcode";
const DaumPostcode = (param)=>{
    let { ...props } = param;
    const handleComplete = useCallback((data)=>{
        props.onComplete(data);
    }, [
        props
    ]);
    return /*#__PURE__*/ _jsx(DaumPostcodeEmbed, {
        autoClose: false,
        theme: {
            bgColor: "#FFFFFF",
            textColor: "#6C6C6D",
            queryTextColor: "#171718",
            postcodeTextColor: "#1288FF",
            emphTextColor: "#171718",
            outlineColor: "#DDDDDD"
        },
        ...props,
        onComplete: handleComplete
    }, props.key);
};
export default DaumPostcode;
